import useDocumentFullscreen from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Hooks/useDocumentFullscreen';
import { Maximize2 } from 'lucide-react';
import type * as React from 'react';
import { Button } from '@verclam/ui-kit';

/** Desktop: first action of the progress card, before the zoom settings. The phone has its own entry at the corner of the viewer. */
const FullscreenEnterButton: React.FC = () => {
	const { enter } = useDocumentFullscreen();

	return (
		<Button
			type="button"
			outlined
			severity="secondary"
			label="Plein écran"
			icon={<Maximize2 size={16} aria-hidden="true" />}
			onClick={enter}
		/>
	);
};

export default FullscreenEnterButton;
